export class BaseDropdownItem {
    public value: string = '';
    public text: string = '';
    public constructor(value: string = '', text: string = ''){
        this.value = value;
        this.text = text;
     }
}